// Data Explorer specific actions. No need to keep this in sync with the one in Portal.
// Some of the enums names are used in Fabric. Please do not rename them.
export var Action;
(function (Action) {
    Action[Action["CollapseTreeNode"] = 0] = "CollapseTreeNode";
    Action[Action["CreateCollection"] = 1] = "CreateCollection";
    Action[Action["CreateGlobalSecondaryIndex"] = 2] = "CreateGlobalSecondaryIndex";
    Action[Action["CreateDocument"] = 3] = "CreateDocument";
    Action[Action["CreateStoredProcedure"] = 4] = "CreateStoredProcedure";
    Action[Action["CreateTrigger"] = 5] = "CreateTrigger";
    Action[Action["CreateUDF"] = 6] = "CreateUDF";
    Action[Action["DeleteCollection"] = 7] = "DeleteCollection";
    Action[Action["DeleteDatabase"] = 8] = "DeleteDatabase";
    Action[Action["DeleteDocument"] = 9] = "DeleteDocument";
    Action[Action["ExpandTreeNode"] = 10] = "ExpandTreeNode";
    Action[Action["ExecuteQuery"] = 11] = "ExecuteQuery";
    Action[Action["HasFeature"] = 12] = "HasFeature";
    Action[Action["GetVNETServices"] = 13] = "GetVNETServices";
    Action[Action["InitializeAccountLocationFromResourceGroup"] = 14] = "InitializeAccountLocationFromResourceGroup";
    Action[Action["InitializeDataExplorer"] = 15] = "InitializeDataExplorer";
    Action[Action["LoadDatabaseAccount"] = 16] = "LoadDatabaseAccount";
    Action[Action["LoadCollections"] = 17] = "LoadCollections";
    Action[Action["LoadDatabases"] = 18] = "LoadDatabases";
    Action[Action["LoadOffers"] = 19] = "LoadOffers";
    Action[Action["MongoShell"] = 20] = "MongoShell";
    Action[Action["ContextualPane"] = 21] = "ContextualPane";
    Action[Action["ScaleThroughput"] = 22] = "ScaleThroughput";
    Action[Action["ToggleAutoscaleSetting"] = 23] = "ToggleAutoscaleSetting";
    Action[Action["SelectItem"] = 24] = "SelectItem";
    Action[Action["Tab"] = 25] = "Tab";
    Action[Action["UpdateDocument"] = 26] = "UpdateDocument";
    Action[Action["UpdateSettings"] = 27] = "UpdateSettings";
    Action[Action["UpdateStoredProcedure"] = 28] = "UpdateStoredProcedure";
    Action[Action["UpdateTrigger"] = 29] = "UpdateTrigger";
    Action[Action["UpdateUDF"] = 30] = "UpdateUDF";
    Action[Action["LoadResourceTree"] = 31] = "LoadResourceTree";
    Action[Action["CreateDatabase"] = 32] = "CreateDatabase";
    Action[Action["ResolveConflict"] = 33] = "ResolveConflict";
    Action[Action["DeleteConflict"] = 34] = "DeleteConflict";
    Action[Action["SaveQuery"] = 35] = "SaveQuery";
    Action[Action["SetupSavedQueries"] = 36] = "SetupSavedQueries";
    Action[Action["LoadSavedQuery"] = 37] = "LoadSavedQuery";
    Action[Action["DeleteSavedQuery"] = 38] = "DeleteSavedQuery";
    Action[Action["ConnectEncryptionToken"] = 39] = "ConnectEncryptionToken";
    Action[Action["SignInAad"] = 40] = "SignInAad";
    Action[Action["SignOutAad"] = 41] = "SignOutAad";
    Action[Action["FetchTenants"] = 42] = "FetchTenants";
    Action[Action["FetchSubscriptions"] = 43] = "FetchSubscriptions";
    Action[Action["FetchAccounts"] = 44] = "FetchAccounts";
    Action[Action["GetAccountKeys"] = 45] = "GetAccountKeys";
    Action[Action["LoadingStatus"] = 46] = "LoadingStatus";
    Action[Action["AccountSwitch"] = 47] = "AccountSwitch";
    Action[Action["SubscriptionSwitch"] = 48] = "SubscriptionSwitch";
    Action[Action["TenantSwitch"] = 49] = "TenantSwitch";
    Action[Action["DefaultTenantSwitch"] = 50] = "DefaultTenantSwitch";
    Action[Action["CreateNotebookWorkspace"] = 51] = "CreateNotebookWorkspace";
    Action[Action["NotebookErrorNotification"] = 52] = "NotebookErrorNotification";
    Action[Action["CreateSparkCluster"] = 53] = "CreateSparkCluster";
    Action[Action["UpdateSparkCluster"] = 54] = "UpdateSparkCluster";
    Action[Action["DeleteSparkCluster"] = 55] = "DeleteSparkCluster";
    Action[Action["LibraryManage"] = 56] = "LibraryManage";
    Action[Action["ClusterLibraryManage"] = 57] = "ClusterLibraryManage";
    Action[Action["ModifyOptionForThroughputWithSharedDatabase"] = 58] = "ModifyOptionForThroughputWithSharedDatabase";
    Action[Action["EnableAzureSynapseLink"] = 59] = "EnableAzureSynapseLink";
    Action[Action["CreateNewNotebook"] = 60] = "CreateNewNotebook";
    Action[Action["OpenSampleNotebook"] = 61] = "OpenSampleNotebook";
    Action[Action["ExecuteCell"] = 62] = "ExecuteCell";
    Action[Action["ExecuteCellPromptBtn"] = 63] = "ExecuteCellPromptBtn";
    Action[Action["ExecuteAllCells"] = 64] = "ExecuteAllCells";
    Action[Action["NotebookEnabled"] = 65] = "NotebookEnabled";
    Action[Action["NotebooksGitHubConnect"] = 66] = "NotebooksGitHubConnect";
    Action[Action["NotebooksGitHubAuthorize"] = 67] = "NotebooksGitHubAuthorize";
    Action[Action["NotebooksGitHubManualRepoAdd"] = 68] = "NotebooksGitHubManualRepoAdd";
    Action[Action["NotebooksGitHubManageRepo"] = 69] = "NotebooksGitHubManageRepo";
    Action[Action["NotebooksGitHubCommit"] = 70] = "NotebooksGitHubCommit";
    Action[Action["NotebooksGitHubDisconnect"] = 71] = "NotebooksGitHubDisconnect";
    Action[Action["NotebooksFetched"] = 72] = "NotebooksFetched";
    Action[Action["NotebooksKernelSpecName"] = 73] = "NotebooksKernelSpecName";
    Action[Action["NotebooksExecuteCellFromMenu"] = 74] = "NotebooksExecuteCellFromMenu";
    Action[Action["NotebooksClearOutputsFromMenu"] = 75] = "NotebooksClearOutputsFromMenu";
    Action[Action["NotebooksInsertCodeCellAboveFromMenu"] = 76] = "NotebooksInsertCodeCellAboveFromMenu";
    Action[Action["NotebooksInsertCodeCellBelowFromMenu"] = 77] = "NotebooksInsertCodeCellBelowFromMenu";
    Action[Action["NotebooksInsertTextCellAboveFromMenu"] = 78] = "NotebooksInsertTextCellAboveFromMenu";
    Action[Action["NotebooksInsertTextCellBelowFromMenu"] = 79] = "NotebooksInsertTextCellBelowFromMenu";
    Action[Action["NotebooksMoveCellUpFromMenu"] = 80] = "NotebooksMoveCellUpFromMenu";
    Action[Action["NotebooksMoveCellDownFromMenu"] = 81] = "NotebooksMoveCellDownFromMenu";
    Action[Action["PhoenixConnection"] = 82] = "PhoenixConnection";
    Action[Action["PhoenixHeartBeat"] = 83] = "PhoenixHeartBeat";
    Action[Action["PhoenixResetWorkspace"] = 84] = "PhoenixResetWorkspace";
    Action[Action["PhoenixDBAccountAllowed"] = 85] = "PhoenixDBAccountAllowed";
    Action[Action["DeleteCellFromMenu"] = 86] = "DeleteCellFromMenu";
    Action[Action["OpenTerminal"] = 87] = "OpenTerminal";
    Action[Action["OpenCloudShellTerminal"] = 88] = "OpenCloudShellTerminal";
    Action[Action["CreateMongoCollectionWithWildcardIndex"] = 89] = "CreateMongoCollectionWithWildcardIndex";
    Action[Action["ClickCommandBarButton"] = 90] = "ClickCommandBarButton";
    Action[Action["RefreshResourceTreeMyNotebooks"] = 91] = "RefreshResourceTreeMyNotebooks";
    Action[Action["ClickResourceTreeNodeContextMenuItem"] = 92] = "ClickResourceTreeNodeContextMenuItem";
    Action[Action["DiscardSettings"] = 93] = "DiscardSettings";
    Action[Action["SettingsV2Updated"] = 94] = "SettingsV2Updated";
    Action[Action["SettingsV2Discarded"] = 95] = "SettingsV2Discarded";
    Action[Action["MongoIndexUpdated"] = 96] = "MongoIndexUpdated";
    Action[Action["NotebooksGalleryPublish"] = 97] = "NotebooksGalleryPublish";
    Action[Action["NotebooksGalleryReportAbuse"] = 98] = "NotebooksGalleryReportAbuse";
    Action[Action["NotebooksGalleryClickReportAbuse"] = 99] = "NotebooksGalleryClickReportAbuse";
    Action[Action["NotebooksGalleryViewCodeOfConduct"] = 100] = "NotebooksGalleryViewCodeOfConduct";
    Action[Action["NotebooksGalleryAcceptCodeOfConduct"] = 101] = "NotebooksGalleryAcceptCodeOfConduct";
    Action[Action["NotebooksGalleryFavorite"] = 102] = "NotebooksGalleryFavorite";
    Action[Action["NotebooksGalleryUnfavorite"] = 103] = "NotebooksGalleryUnfavorite";
    Action[Action["NotebooksGalleryClickDelete"] = 104] = "NotebooksGalleryClickDelete";
    Action[Action["NotebooksGalleryDelete"] = 105] = "NotebooksGalleryDelete";
    Action[Action["NotebooksGalleryClickDownload"] = 106] = "NotebooksGalleryClickDownload";
    Action[Action["NotebooksGalleryDownload"] = 107] = "NotebooksGalleryDownload";
    Action[Action["NotebooksGalleryViewNotebook"] = 108] = "NotebooksGalleryViewNotebook";
    Action[Action["NotebooksGalleryViewGallery"] = 109] = "NotebooksGalleryViewGallery";
    Action[Action["NotebooksGalleryViewOfficialSamples"] = 110] = "NotebooksGalleryViewOfficialSamples";
    Action[Action["NotebooksGalleryViewPublicGallery"] = 111] = "NotebooksGalleryViewPublicGallery";
    Action[Action["NotebooksGalleryViewFavorites"] = 112] = "NotebooksGalleryViewFavorites";
    Action[Action["NotebooksGalleryViewPublishedNotebooks"] = 113] = "NotebooksGalleryViewPublishedNotebooks";
    Action[Action["NotebooksGalleryClickPublishToGallery"] = 114] = "NotebooksGalleryClickPublishToGallery";
    Action[Action["NotebooksGalleryOfficialSamplesCount"] = 115] = "NotebooksGalleryOfficialSamplesCount";
    Action[Action["NotebooksGalleryPublicGalleryCount"] = 116] = "NotebooksGalleryPublicGalleryCount";
    Action[Action["NotebooksGalleryFavoritesCount"] = 117] = "NotebooksGalleryFavoritesCount";
    Action[Action["NotebooksGalleryPublishedCount"] = 118] = "NotebooksGalleryPublishedCount";
    Action[Action["SelfServe"] = 119] = "SelfServe";
    Action[Action["ExpandAddCollectionPaneAdvancedSection"] = 120] = "ExpandAddCollectionPaneAdvancedSection";
    Action[Action["ExpandAddGlobalSecondaryIndexPaneAdvancedSection"] = 121] = "ExpandAddGlobalSecondaryIndexPaneAdvancedSection";
    Action[Action["SchemaAnalyzerClickAnalyze"] = 122] = "SchemaAnalyzerClickAnalyze";
    Action[Action["SelfServeComponent"] = 123] = "SelfServeComponent";
    Action[Action["LaunchQuickstart"] = 124] = "LaunchQuickstart";
    Action[Action["NewContainerHomepage"] = 125] = "NewContainerHomepage";
    Action[Action["Top3ItemsClicked"] = 126] = "Top3ItemsClicked";
    Action[Action["LearningResourcesClicked"] = 127] = "LearningResourcesClicked";
    Action[Action["PlayCarouselVideo"] = 128] = "PlayCarouselVideo";
    Action[Action["OpenCarousel"] = 129] = "OpenCarousel";
    Action[Action["CompleteCarousel"] = 130] = "CompleteCarousel";
    Action[Action["LaunchUITour"] = 131] = "LaunchUITour";
    Action[Action["CancelUITour"] = 132] = "CancelUITour";
    Action[Action["CompleteUITour"] = 133] = "CompleteUITour";
    Action[Action["OpenQueryCopilotFromSplashScreen"] = 134] = "OpenQueryCopilotFromSplashScreen";
    Action[Action["OpenQueryCopilotFromNewQuery"] = 135] = "OpenQueryCopilotFromNewQuery";
    Action[Action["ActivateQueryCopilot"] = 136] = "ActivateQueryCopilot";
    Action[Action["DeactivateQueryCopilot"] = 137] = "DeactivateQueryCopilot";
    Action[Action["QueryGenerationFromCopilotPrompt"] = 138] = "QueryGenerationFromCopilotPrompt";
    Action[Action["QueryEdited"] = 139] = "QueryEdited";
    Action[Action["ExecuteQueryGeneratedFromQueryCopilot"] = 140] = "ExecuteQueryGeneratedFromQueryCopilot";
    Action[Action["DeleteDocuments"] = 141] = "DeleteDocuments";
    Action[Action["ReadPersistedTabState"] = 142] = "ReadPersistedTabState";
    Action[Action["SavePersistedTabState"] = 143] = "SavePersistedTabState";
    Action[Action["DeletePersistedTabState"] = 144] = "DeletePersistedTabState";
    Action[Action["UploadDocuments"] = 145] = "UploadDocuments";
    Action[Action["CloudShellUserConsent"] = 146] = "CloudShellUserConsent";
    Action[Action["CloudShellTerminalSession"] = 147] = "CloudShellTerminalSession";
    Action[Action["OpenVSCode"] = 148] = "OpenVSCode";
    Action[Action["ImportSampleData"] = 149] = "ImportSampleData";
})(Action || (Action = {}));
export const ActionModifiers = {
    Start: "start",
    Success: "success",
    Failed: "failed",
    Mark: "mark",
    Open: "open",
    IFrameReady: "iframeready",
    Close: "close",
    Submit: "submit",
    IndexAll: "index all properties",
    NoIndex: "no indexing",
    Cancel: "cancel",
    ToggleAutoscaleOn: "autoscale on",
    ToggleAutoscaleOff: "autoscale off",
};
export var SourceBlade;
(function (SourceBlade) {
    SourceBlade[SourceBlade["AddCollection"] = 0] = "AddCollection";
    SourceBlade[SourceBlade["AzureFunction"] = 1] = "AzureFunction";
    SourceBlade[SourceBlade["BrowseCollectionBlade"] = 2] = "BrowseCollectionBlade";
    SourceBlade[SourceBlade["CassandraAccountCreateBlade"] = 3] = "CassandraAccountCreateBlade";
    SourceBlade[SourceBlade["CollectionSetting"] = 4] = "CollectionSetting";
    SourceBlade[SourceBlade["DatabaseAccountCreateBlade"] = 5] = "DatabaseAccountCreateBlade";
    SourceBlade[SourceBlade["DataExplorer"] = 6] = "DataExplorer";
    SourceBlade[SourceBlade["DeleteCollection"] = 7] = "DeleteCollection";
    SourceBlade[SourceBlade["DeleteDatabase"] = 8] = "DeleteDatabase";
    SourceBlade[SourceBlade["DocumentExplorer"] = 9] = "DocumentExplorer";
    SourceBlade[SourceBlade["FirewallVNETBlade"] = 10] = "FirewallVNETBlade";
    SourceBlade[SourceBlade["Metrics"] = 11] = "Metrics";
    SourceBlade[SourceBlade["NonDocumentDBAccountCreateBlade"] = 12] = "NonDocumentDBAccountCreateBlade";
    SourceBlade[SourceBlade["OverviewBlade"] = 13] = "OverviewBlade";
    SourceBlade[SourceBlade["QueryExplorer"] = 14] = "QueryExplorer";
    SourceBlade[SourceBlade["Quickstart"] = 15] = "Quickstart";
    SourceBlade[SourceBlade["ReaderWarning"] = 16] = "ReaderWarning";
    SourceBlade[SourceBlade["ResourceMenu"] = 17] = "ResourceMenu";
    SourceBlade[SourceBlade["RpcProvider"] = 18] = "RpcProvider";
    SourceBlade[SourceBlade["ScaleCollection"] = 19] = "ScaleCollection";
    SourceBlade[SourceBlade["ScriptExplorer"] = 20] = "ScriptExplorer";
    SourceBlade[SourceBlade["Keys"] = 21] = "Keys";
})(SourceBlade || (SourceBlade = {}));
export var Source;
(function (Source) {
    Source["ResourceTreeMenu"] = "ResourceTreeMenu";
    Source["CommandBarMenu"] = "CommandBarMenu";
})(Source || (Source = {}));
